module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/GUNPOWDER-Layered.969bb57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/GUNPOWDER-Layered.jpg
// module id = 730r
// module chunks = 0